import React, { useEffect, useRef } from "react";
import "./StartupProjects.css";
import { Link } from "react-router-dom";
import Reveal from "../../components/reveal/Reveal";
import ScrollWords from "../../components/scrollWords/ScrollWords";
import { gsap, prefersReducedMotion } from "../../utils/gsap";
import ProjectsData from "../../shared/opensource/projects.json";

const FEATURED = 6;

export default function StartupProject() {
  const projects = ProjectsData.data.slice(0, FEATURED);
  const root = useRef(null);

  useEffect(() => {
    if (prefersReducedMotion()) return undefined;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".work-section .sw",
        { opacity: 0.12, y: 18 },
        {
          opacity: 1,
          y: 0,
          stagger: 0.1,
          ease: "none",
          scrollTrigger: {
            trigger: ".work-section .section-title",
            start: "top 88%",
            end: "bottom 55%",
            scrub: true,
          },
        }
      );
      gsap.utils.toArray(".work-card").forEach((card) => {
        const st = {
          trigger: card,
          start: "top 80%",
          toggleActions: "play none none reverse",
        };
        gsap.from(card.querySelectorAll(".work-tag"), {
          y: 14,
          scale: 0.7,
          opacity: 0,
          duration: 0.5,
          stagger: 0.07,
          ease: "back.out(2)",
          scrollTrigger: st,
        });
        gsap.from(card.querySelector(".work-name"), {
          clipPath: "inset(0 100% 0 0)",
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: st,
        });
      });
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section className="work-section" id="projects" ref={root}>
      <div className="section-inner">
        <Reveal>
          <div className="section-head work-head">
            <div>
              <span className="section-kicker">Selected work</span>
              <h2 className="section-title">
                <ScrollWords
                  lines={["Products I've designed,", "built and shipped."]}
                />
              </h2>
            </div>
            <Link to="/projects" className="btn btn-ghost">
              All projects →
            </Link>
          </div>
        </Reveal>
        <div className="work-grid">
          {projects.map((p, i) => (
            <Reveal key={p.name} delay={(i % 3) * 120} className="reveal-fill">
              <article className="work-card">
                <span className="cap-num">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="work-name">{p.name}</h3>
                <p className="work-desc">{p.description}</p>
                <div className="work-tags">
                  {p.languages.map((l) => (
                    <span className="work-tag" key={l.name}>
                      {l.name}
                    </span>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
